module.exports = __webpack_public_path__ + "img/successIcon.fbcc3c33.svg";